import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const generationsSearchSchema = z.object({
  model: z.string().optional(),
  type: z.string().optional(),
})

export const Route = createFileRoute('/dashboard/generations')({
  validateSearch: generationsSearchSchema,
})
